import { Injectable } from '@angular/core';
import { ILogger } from './logger.service';

/* eslint-disable no-console */

@Injectable()
export class ConsoleLogHandlerService implements ILogger {
  constructor() {}

  debug(message?: any, ...optionalParams: any[]): void {
    console?.debug(message, ...optionalParams);
  }

  info(message?: any, ...optionalParams: any[]): void {
    console?.info(message, ...optionalParams);
  }

  log(message?: any, ...optionalParams: any[]): void {
    console?.log(message, ...optionalParams);
  }

  warn(message?: any, ...optionalParams: any[]): void {
    console?.warn(message, ...optionalParams);
  }

  error(message?: any, ...optionalParams: any[]): void {
    console?.error(message, ...optionalParams);
  }
}
